<template>
  <td>
    {{ model.ins_outs }}
  </td>
</template>

<script>
export default {
  props: ["model"]
};
</script>
